module.exports = __webpack_public_path__ + "static/media/test3.d535c48e.jpeg";